import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { type DisplayableError, ErrorBoundaryWithAsyncContext, type ErrorBoundaryProps } from "@repo/ui";
import { type ErrorInfo, type FC } from "react";

export const AppInsightsErrorBoundary: FC<Omit<ErrorBoundaryProps, "trackException">> = ({ children, ...props }) => {
    const reactPlugin = useAppInsightsContext();

    const trackException = (error: Error | DisplayableError, errorInfo?: ErrorInfo) => {
        if ((error as DisplayableError).doNotTrack !== true) {
            reactPlugin.trackException({
                error,
                exception: error,
                severityLevel: SeverityLevel.Error,
                properties: errorInfo,
            });
        }
    };

    return (
        <ErrorBoundaryWithAsyncContext trackException={trackException} {...props}>
            {children}
        </ErrorBoundaryWithAsyncContext>
    );
};
